<template>
  <div class="home">
    <i
      class="fad fa-fish fa-10x fa-swap-opacity"
      style="--fa-primary-color: black; --fa-secondary-color: darksalmon;"
    ></i>
    <h1>Phish Challenge</h1>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home"
};
</script>
